// extracted by mini-css-extract-plugin
export default {"wrapper":"file-upload-controller_wrapper__JWfgE","name":"file-upload-controller_name__ySBEY"};